import {OrderStatus} from '@yandex-taxi/js-integration-api'

import {activeOrderStatuses} from './consts'

export type OrdersProps = {
  activeOrderID?: string
}

export const isActiveStatus = (status: OrderStatus) => activeOrderStatuses.indexOf(status) > -1
